import { render } from "./AllocationDetail.vue?vue&type=template&id=4f3d2501&scoped=true"
import script from "./AllocationDetail.vue?vue&type=script&lang=js"
export * from "./AllocationDetail.vue?vue&type=script&lang=js"

import "./AllocationDetail.vue?vue&type=style&index=0&id=4f3d2501&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4f3d2501"
/* hot reload */
if (module.hot) {
  script.__hmrId = "4f3d2501"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4f3d2501', script)) {
    api.reload('4f3d2501', script)
  }
  
  module.hot.accept("./AllocationDetail.vue?vue&type=template&id=4f3d2501&scoped=true", () => {
    api.rerender('4f3d2501', render)
  })

}

script.__file = "src/components/AllocationDetail.vue"

export default script